<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>通用管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/upLogList')">升级规则列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">

      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="id"
            :formatter="formatterRoleType"
            label="代理类型"
          >
          </el-table-column>
          <el-table-column
            label="保证金"
            prop="deposit"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType > 2.2">{{scope.row.deposit}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="升级购物金额"
            prop="payMoney"
          >
            <template slot-scope="scope">
              <span>{{scope.row.payMoney}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="保证金说明"
            prop="depositMsg"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType > 1">{{scope.row.depositMsg}}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            label="最低购物"
            prop="lowMoney"
          >
            <template slot-scope="scope">
              <span>{{scope.row.lowMoney}}</span>
            </template>
          </el-table-column>



          <el-table-column
            label="从康减系列VIP会员升级金额"
            prop="unitMoney"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType > -0.5">{{scope.row.unitMoney}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="从康减系列高级会员升级金额"
            prop="unitSecondPrice"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType > -0.4">{{scope.row.unitSecondPrice}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="从康减系列荣誉会员升级金额"
            prop="unitThreePrice"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType > -0.3">{{scope.row.unitThreePrice}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="从康减系列市代升级金额"
            prop="unitCityMoney"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType > 1.1">{{scope.row.unitCityMoney}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="从康减系列省代升级金额"
            prop="unitProvinceMoney"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType > 2.1">{{scope.row.unitProvinceMoney}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="从康减系列CEO升级金额"
            prop="unitCEOMoney"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType > 3.1">{{scope.row.unitCEOMoney}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="从VIP升级金额"
            prop="districtMoney"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType > 0">{{scope.row.districtMoney}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="从联盟店升级金额"
            prop="cityMoney"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType > 1">{{scope.row.cityMoney}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="从优秀高级升级金额"
            prop="provinceMoney"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType > 1.05">{{scope.row.niceDisMoney}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="从市代升级金额"
            prop="provinceMoney"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType > 2">{{scope.row.provinceMoney}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="从省代升级金额"
            prop="ceoMoney"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType > 3">{{scope.row.ceoMoney}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="从合伙人升级金额"
            prop="ceoMoney"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType > 2.2">{{scope.row.ceoMoney}}</span>
            </template>
          </el-table-column>

          <el-table-column
            width="200"
            label="赠送商品"
            :formatter="formatterSendGood"
          >

          </el-table-column>

          <el-table-column
            label="要求"
            prop="checkType"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.checkType == 4">完善信息购物</span>
              <span v-if="scope.row.checkType == 1">交保证金购买商品</span>
              <span v-if="scope.row.checkType == 2">提交审核通过后交保证金购买商品</span>
              <span v-if="scope.row.checkType == 3">后台设置</span>
            </template>
          </el-table-column>

          <el-table-column
            label="学习积分"
            prop="sendIntegral"
          >
            <template slot-scope="scope">
              <span>{{scope.row.sendIntegral}}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column
            label="保证金协议"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.roleType != 4 && scope.row.roleType > 1"
                @click="editDepositContentDialog(scope.row)"
                type="text"
                size="small"
              >编辑</el-button>
            </template>
          </el-table-column> -->
          <el-table-column
            label="操作"
            fixed="right"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
              v-if="hasPower('60051991')"
                @click="editPostDialog(scope.row)"
                type="text"
                size="small"
              >编辑</el-button>

              <el-button
              v-if="hasPower('60051991') && scope.row.roleType == 1"
                @click="showPostDialog(scope.row)"
                type="text"
                size="small"
              >升级金额</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      title="省份升级金额"
      :visible.sync="subListVisible"
      width="70%"
    >
    <div class="contain_header clr">
        <el-button
              type="primary"
              @click="addDialog"
            >新增</el-button>
      </div>

      <el-table
        v-loading="detailListLoading"
        :data="tableDetailData"
        style="width: 100%"
        max-height="500"
        :header-cell-class-name='objectSpanMethod'
      >
        <el-table-column
          prop="provinceName"
          label="省"
        >
        </el-table-column>

        <el-table-column
          prop="lowMoney"
          label="升级购物金额"
        >
        </el-table-column>

        <el-table-column
          prop="unitMoney"
          label="康减系列VIP会员升级金额"
        >
        </el-table-column>

        <el-table-column
          prop="unitSecondPrice"
          label="康减系列高级会员升级金额"
        >
        </el-table-column>

        <el-table-column
          prop="unitThreePrice"
          label="康减系列荣誉会员升级金额"
        >
        </el-table-column>

        <el-table-column
          prop="districtMoney"
          label="VIP门店升级金额"
        >
        </el-table-column>

        <el-table-column
            label="操作"
            fixed="right"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
              v-if="hasPower('60051991')"
                @click="editDialog(scope.row)"
                type="text"
                size="small"
              >编辑</el-button>

            </template>
          </el-table-column>

      </el-table>
      <div class="pageDiv block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange1"
          :current-page.sync="page_num1"
          :page-count='total_page1'
          :page-size="page_size1"
          layout="total, prev, pager, next"
          :total="total_num1"
        >
        </el-pagination>
      </div>

    </el-dialog>

    <el-dialog :title="opDia" :visible.sync="addUpInfoDialog" width="40%">
      <el-form label-position="top" class="m-search" size="small" :model="form2" ref="form2" :rules="addForm2Rule">
        <el-form-item label="省份" prop="provinceId">
          <el-select v-model="form2.provinceId" placeholder="请选择">
            <el-option
                    v-for="option in provinceOptions"
                    :value="option.value"
                    :key='option.value'
                    :label="option.label"
                  ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="升级购物金额" prop="lowMoney">
          <el-input
            v-model="form2.lowMoney"
            placeholder="请填写升级购物金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="康减系列VIP会员升级金额" prop="unitMoney">
          <el-input
            v-model="form2.unitMoney"
            placeholder="请填写康减系列VIP会员升级金额"
          ></el-input>
        </el-form-item>

        <el-form-item label="康减系列高级会员升级金额" prop="unitSecondPrice">
          <el-input
            v-model="form2.unitSecondPrice"
            placeholder="请填写康减系列高级会员升级金额"
          ></el-input>
        </el-form-item>

        <el-form-item label="康减系列荣誉会员升级金额" prop="unitThreePrice">
          <el-input
            v-model="form2.unitThreePrice"
            placeholder="请填写康减系列荣誉会员升级金额"
          ></el-input>
        </el-form-item>

        <el-form-item label="VIP门店升级金额" prop="districtMoney">
          <el-input
            v-model="form2.districtMoney"
            placeholder="请填写VIP门店升级金额"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="throwGroupUp11()" :loading="ceoLoading1">提交</el-button>
          <el-button @click="addUpInfoDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </el-main>

  
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
export default {
  name: "upLogList",
  created() {},

  data() {
    return {
      provinceOptions:[],
      ceoLoading1:false,
      addUpInfoDialog:false,
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      addFormRule: {
        typeName: [
          { required: true, message: "请输入分类名称", trigger: "blur" }
        ],
        status: [
          { required: true, message: "请选择上架状态", trigger: "blur" }
        ],
        listPic: [
          { required: true, message: "请上传首页列表图片", trigger: "blur" }
        ],
        mainPic: [
          { required: true, message: "请上传筛选顶部图片", trigger: "blur" }
        ]
      },
      addForm2Rule: {
        ruleId: [
          { required: true, message: "请选择升级记录", trigger: "blur" }
        ],
        lowMoney: [
          { required: true, message: "请填写升级金额", trigger: "blur" }
        ],
        unitMoney: [
          { required: true, message: "请填写康减系列VIP会员升级金额", trigger: "blur" }
        ],
        unitSecondPrice: [
          { required: true, message: "请填写康减系列高级会员升级金额", trigger: "blur" }
        ],
        unitThreePrice: [
          { required: true, message: "请填写康减系列荣誉会员升级金额", trigger: "blur" }
        ],
        districtMoney: [
          { required: true, message: "请填写VIP门店升级金额", trigger: "blur" }
        ],
        provinceId: [
          { required: true, message: "请选择省份", trigger: "blur" }
        ]
      },
      addLoading: false,
      searchGoodId:null,
      subListVisible: false,
      loading: false,
      form: {
        infoType: 2,
        status: null,
        typeName: null,
        pid: null,
        mainPic: null,
        listPic: null,
        id: null
      },
      dialogPics: [],
      dialogEditVisible: false,
      dialogContent: "",
      dialogTitle: "",
      dialogVisible: false,
      filters: {
        status: null,
        keyword: null,
        pid: null
      },
      isCollapse: true,
      activeName: "second",
      dialogAddVisible: false,
      form2:{
        id:null,
        ruleId:null,
        lowMoney:null,
        unitMoney:null,
        unitSecondPrice:null,
        unitThreePrice:null,
        districtMoney:null,
        provinceId:null
      },
      backFirst: 1,
      page_num: 1,
      opDia:'',
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      options: [{ text: "待上架", value: "1" }, { text: "上架", value: "2" }],
      typeOptions: null,
      tableData: [],
      total_num: 0,
      detailListLoading: false,
      total_page: 0,
      page_size: 10,
      tableDetailData: [],
      total_num1: 0,
      page_num1:0,
      total_page1: 0,
      page_size1: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    var that = this;
    API.get_province_list({
          token: localStorage.getItem("api_token")})
            .then(
              function(result) {
                if (result && parseInt(result.key) === 1000) {
                  that.provinceOptions = result.result.list;
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message,
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
  },
  activated(){
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    addDialog() {
      this.form2.id = null;
      this.form2.ruleId = this.searchGoodId;
      this.form2.lowMoney = null;
      this.form2.unitMoney = null;
      this.form2.unitSecondPrice = null;
      this.form2.unitThreePrice = null;
      this.form2.districtMoney = null;
      this.form2.provinceId = null;
      this.opDia = '新增下单金额';
      this.addUpInfoDialog = true;
    },
     editDialog(row) {
      this.form2.id = row.id;
      this.form2.ruleId = row.ruleId;
      this.form2.lowMoney = row.lowMoney;
      this.form2.unitMoney = row.unitMoney;
      this.form2.unitSecondPrice = row.unitSecondPrice;
      this.form2.unitThreePrice = row.unitThreePrice;
      this.form2.districtMoney = row.districtMoney;
      this.form2.provinceId = row.provinceId;
      this.opDia = '修改下单金额';
      this.addUpInfoDialog = true;
    },
    formatterSendGood(row, column) {
      if (row.sendGood != null  && row.sendGood != '')
      {
        var list = JSON.parse(row.sendGood);
        var info = [];
        for (var i=0;i<list.length; i++)
        {
          info.push('名称:' + list[i].title + "  数量:" + list[i].goodNum);
        }
        return info.join(';');
      } else {
        return '暂无';
      }
    },
    throwGroupUp11() {
      var that = this;
      that.$refs["form2"].validate(valid => {
        if (valid) {
          console.log('校验结果：' + valid)
          let para = {
            token: localStorage.getItem("api_token"),
            id: that.form2.id,
            ruleId: that.form2.ruleId,
            lowMoney: that.form2.lowMoney,
            unitMoney: that.form2.unitMoney,
            unitSecondPrice: that.form2.unitSecondPrice,
            unitThreePrice: that.form2.unitThreePrice,
            districtMoney: that.form2.districtMoney,
            provinceId: that.form2.provinceId
          };
          that.ceoLoading1 = true;
          API.add_edit_rule_province(para)
            .then(
              function(result) {
                that.ceoLoading1 = false;
                if (result && parseInt(result.key) === 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "操作成功",
                    duration: 1500
                  });
                  that.addUpInfoDialog = false;
                  that.searchDetail();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.ceoLoading1 = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.ceoLoading1 = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },
    formatterRoleType(row, column) {
      if (row.roleType == -1) {
        return "无";
      } else if (row.roleType == 0) {
        return "VIP门店";
      } else if (row.roleType == -0.5) {
        return "康减系列vip会员";
      } else if (row.roleType == -0.4) {
        return "康减系列高级会员";
      } else if (row.roleType == -0.3) {
        return "康减系列荣誉会员";
      } else if (row.roleType == 1) {
        
        if (row.provinceType == 4)
        {
          return "康减康庭系列联盟店";
        } else if (row.provinceType == 5) {
          return "康颜单项联盟店";
        } else {
          return "联盟店";
        }
      } else if (row.roleType == 2) {
        return "市代";
      } else if (row.roleType == 3) {
        if (row.provinceType == 1)
        {
          return "门店省代";
        } else {
          return "战略省代";
        }
      } else if (row.roleType == 4) {
        return "CEO";
      } else if (row.roleType == 1.1) {
        return "康减系列市代";
      } else if (row.roleType == 2.1) {
        return "康减系列省代";
      } else if (row.roleType == 3.1) {
        return "康减系列CEO";
      } else if (row.roleType == 1.05) {
        return "优秀联盟店";
      } else if (row.roleType == 5) {
        return "总经销商 ";
      } else if (row.roleType == 2.2) {
        return "合伙人";
      } else if (row.roleType == 4.2) {
        return "董事";
      } else if (row.roleType == 5.1) {
        return "区域总监";
      } else if (row.roleType == 5.2) {
        return "城市加盟商";
      } else if (row.roleType == 4.8) {
        return "经销商";
      }
    },
    beforeAvatarUpload: function(e) {},
    beforeAvatarUpload1: function(e) {},
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.listPic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess1: function(e) {
      if (e.key == 1000) {
        this.form.mainPic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    showPostDialog(row){
      let that = this;
      that.subListVisible = true;
      this.page_size1 = 10;
      this.page_num1 = 1;
      this.searchGoodId = row.id;
      this.searchDetail();
    },
    editPostDialog(row) {
      this.$router.push({ path: "/editUpRule", query: { good: row } });
    },
    // editDepositContentDialog(row) {
    //   this.$router.push({ path: "/editDepositContent", query: { good: row } });
    // },
    upHouseStatus(row, status) {
      let that = this;
      var m1 = "";
      var m2 = "";
      var m3 = "";
      var type = "";
      if (status == 1) {
        m1 = "确定取消上架该商品分类吗？";
        m2 = "取消成功后，app就不显示该分类";
        m3 = "取消成功";
        type = "warning";
      } else if (status == 2) {
        m1 = "确定上架该商品分类吗？";
        m2 = "上架成功后，app就会显示该分类";
        m3 = "上架成功";
        type = "success";
      } else {
        m1 = "确定删除该商品分类吗？";
        m2 = "删除成功后，app和后台都不显示该分类";
        m3 = "删除成功";
        type = "error";
      }
      this.$confirm(m1, m2, { type: type })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            id: row.id,
            status: status
          };
          API.status_good_type(para)
            .then(
              function(result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {
                  if (para.status == 3) {
                    that.typeOptions = null;
                  }
                  that.$message.success({
                    showClose: true,
                    message: m3,
                    duration: 1500
                  });
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    },
    handleSearch() {
      this.search();
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    searchDetail() {
      let that = this;
      let params = {
        page_num: that.page_num1,
        rule_id:this.searchGoodId,
        page_size: that.page_size1,
        token: localStorage.getItem("api_token")
      };
      that.detailListLoading = true;
      API.rule_province_list(params)
        .then(
          function(result) {
            that.detailListLoading = false;
            if (result.key == 1000) {
              that.total_num1 = result.result.count;
              that.total_page1 = result.result.allPageNumber;
              var list = [];
              if (result.result.list && result.result.list.length > 0) {
                for (var i=0; i<result.result.list.length; i++)
                {
                  // if (result.result.list[i].roleType == -0.5 || result.result.list[i].roleType == -0.3 || result.result.list[i].roleType == 5.1 || result.result.list[i].roleType == 1 || result.result.list[i].roleType == 2.2 || result.result.list[i].roleType == 4.2)
                  // {
                  //   list.push(result.result.list[i])
                  // }
                  list.push(result.result.list[i])
                }
              }
              that.tableDetailData = list;
            } else if (result.key == 1001) {
              bus.$emit("goto", "/login");
            }
          },
          function(err) {
            that.detailListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.detailListLoading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    search() {
      let that = this;
      let params = {
        page_num: 1,
        page_size: 20,
        token: localStorage.getItem("api_token")
      };
      that.loading = true;
      API.up_role_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              var list = [];
              if (result.result.list && result.result.list.length > 0) {
                for (var i=0; i<result.result.list.length; i++)
                {
                  // if (result.result.list[i].roleType == -0.5 || result.result.list[i].roleType == -0.3 || result.result.list[i].roleType == 5.1 || result.result.list[i].roleType == 1 || result.result.list[i].roleType == 2.2 || result.result.list[i].roleType == 4.2)
                  // {
                  //   list.push(result.result.list[i])
                  // }
                  list.push(result.result.list[i])
                }
              }
              that.tableData = list;
            } else if (result.key == 1001) {
              bus.$emit("goto", "/login");
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    },
    handleCurrentChange1(val) {
      this.searchDetail();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/upLogList.vue